const FACILITY_PARAM_NAMES = [
  'facilityId',
  'facility_id',
  'facilityid',
  'facId',
  'clientFacilityId',
];

const CLIENT_PARAM_NAMES = ['clientId', 'client_id', 'clientid'];

function findParamValue(
  params: URLSearchParams,
  names: string[]
): string | null {
  const keys = Array.from(params.keys());
  for (const name of names) {
    const key = keys.find((k) => k.toLowerCase() === name.toLowerCase());
    if (!key) {
      continue;
    }
    const value = params.get(key);
    if (value != null && value.trim() !== '') {
      return value.trim();
    }
  }
  return null;
}

export function readFacilityIdFromSearch(
  search: string = typeof window !== 'undefined' ? window.location.search : ''
): number | null {
  const raw = findParamValue(new URLSearchParams(search), FACILITY_PARAM_NAMES);
  if (raw == null) {
    return null;
  }
  const parsed = Number(raw);
  return !Number.isNaN(parsed) && parsed > 0 ? parsed : null;
}

export function readClientIdFromSearch(
  search: string = typeof window !== 'undefined' ? window.location.search : ''
): number | null {
  const raw = findParamValue(new URLSearchParams(search), CLIENT_PARAM_NAMES);
  if (raw == null) {
    return null;
  }
  const parsed = Number(raw);
  return !Number.isNaN(parsed) && parsed > 0 ? parsed : null;
}

export function isEmbedTestPage(pathname: string): boolean {
  return (
    pathname.includes('vob-webform-demo') ||
    pathname.includes('webform-test')
  );
}
